import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreTagsByIdDeleteAsyncSlice } from './delete';
import { coreTagsByIdPutAsyncSlice } from './put';

export const coreTagsByIdReducers = combineReducers({
	delete: coreTagsByIdDeleteAsyncSlice.asyncReducers,
	put: coreTagsByIdPutAsyncSlice.asyncReducers
});

export const coreTagsByIdWatchers = combineAllWatchers([
	coreTagsByIdDeleteAsyncSlice.asyncWatchers,
	coreTagsByIdPutAsyncSlice.asyncWatchers
]);
